import * as z from 'zod/mini';

import { createStorageKeySchema } from '../../../services/storage';
import type { WalletBookSchema } from '../legacyWalletBook.types';

/**
 * The schema to store the cached wallet book data.
 */
export const walletBookCacheStorageKeySchema = createStorageKeySchema({
  key: 'legacyWalletBookCache',
  schema: z.object({
    groups: z.record(z.string(), z.any()),
    wallets: z.record(z.string(), z.any()),
  }) as z.ZodMiniType<WalletBookSchema>,
});
